import styled from 'styled-components';
import { FlexDiv, GenericDiv, GenericSpan } from 'common/Styles';

export const HotelTileContainer = styled(FlexDiv)(
	({ theme: { down, breakpoints } }) => `
				display: grid;
				grid-template-columns: repeat(3, 1fr);
        ${down(breakpoints.md)} {
						flex-wrap: nowrap;
						overflow-x: scroll;
						grid-auto-flow: column;
        }
    `
);

export const HotelTileWrap = styled(FlexDiv)(
	({ theme: { down, breakpoints } }) => `
				width:375px;
				&.highlighted-tile{
					background: linear-gradient(139.14deg, #EFFFE2 0%, #DCF2FF 100%), #FFFFFF;
					border-radius: 4px;
				}
        ${down(breakpoints.md)} {
					width: 235px;
					flex-shrink: 0;
					margin-right: 16px;
        }
    `
);

export const AmenitiesWrap = styled(GenericDiv)`
	display : ${(props)=>props.flex && 'flex'}
	margin-top: ${(props)=>props.flex && '5px'}
	justify-content : ${(props)=>props.flex && 'space-between'}
`;

export const DestinationListItemTop = styled.div`
	padding: 8px 8px 0px;
	height: 170px
	position: relative;
	.popularTag {
		display: flex;
		align-items: center;
		position: absolute;
		top: 8px;
		right: -6px;
		.popularTag-side {
				content: "";
				width: 10px;
				height: 20px;
				display: block;
				background: transparent;
		}
		.popularTag-side:before {
				content: "";
				display: block;
				background: transparent;
				border: 5px solid #008CFF;
				border-bottom-color: transparent;
				border-left-color: transparent;
				position: relative;
		}
		.popularTag-side:after {
				content: "";
				display: block;
				background: transparent;
				border: 5px solid #008CFF;
				border-top-color: transparent;
				border-left-color: transparent;
				position: relative;
		}
		.popularTag-content {
				font-size: 11px;
				color: #fff;
				font-weight: 700;
				line-height: 16px;
				padding: 2px 4px;
				background: linear-gradient(-90deg, #26ABBD 0%, #008CFF 100%);
		}
}
.popularTag:after {
		content: "";
		position: absolute;
		border: 3px solid #125A96;
		border-bottom-color: transparent;
		border-right-color: transparent;
		right: 0;
		top: 20px;
}
.destinationListItem-top_placeName {
	padding: 2px;
	background: linear-gradient(89.27deg, #FF7F3F 0.01%, #FF3E5E 100.01%);
	border-radius: 2px;
	position: absolute;
	top: 15px;
	left: 16px;
	color: #ffffff;
	font-size: 10px;
	font-weight: 700;
	text-transform: uppercase;
}
`;

export const ItemTopImage = styled.img`
	height: 161px;
	width: 100%;
	border-radius: 4px;
	object-fit: cover;
`;

export const ItemTopPlaceHolder = styled.div`
	height: 161px;
	width: 100%;
	border-radius: 6px;
	font-size: 32px;
	font-weight: 900;
	color: #B49F9F;
	display: flex;
	align-items: center;
	text-align: center;
	background: #FCF6F6;
`;

export const HiglightedTag = styled.p`
		display: flex;
		align-items: center;
		position: absolute;
		top: 16px;
		right: 2px;
		&:after{
			content: "";
			position: absolute;
			border: 3px solid #125A96;
			border-bottom-color: transparent;
			border-right-color: transparent;
			right: 0;
			top: 20px;
		}
`;
export const HiglightedTagSide = styled.span`
		content: "";
		width: 10px;
		height: 20px;
		display: block;
		background: transparent;
		&:before {
		content: "";
		display: block;
		background: transparent;
		border: 5px solid #008CFF;
		border-bottom-color: transparent;
		border-left-color: transparent;
		position: relative;
		}
		&:after {
		content: "";
		display: block;
		background: transparent;
		border: 5px solid #008CFF;
		border-top-color: transparent;
		border-left-color: transparent;
		position: relative;
		}
`;
export const HiglightedTagContent = styled.span`
		font-size: 11px;
		color: #fff;
		font-weight: 700;
		line-height: 16px;
		padding: 2px 4px;
		text-transform: uppercase;
		background: linear-gradient(-90deg, #26ABBD 0%, #008CFF 100%);
`;
export const TopPlaceName = styled(GenericSpan)`
		padding: 2px;
		background: linear-gradient(89.27deg, #FF7F3F 0.01%, #FF3E5E 100.01%);
		border-radius: 2px;
		position: absolute;
		top: 15px;
		left: 16px;
		color: #ffffff;
		font-size: 10px;
		font-weight: 700;
		text-transform: uppercase;
`;

export const AmenitiesList = styled('ul')`
		display: ${(props)=>props.isMobile && 'flex'};
		flex-direction: ${(props)=>props.isMobile && 'column'};
		margin-top: 5px;
		line-height: 18px;
		& .desktop{
			display: 'inline';
		}
`;

export const AmentiesDot = styled(GenericSpan)`
	width: 4px;
	height: 4px;
	display: inline-block;
	content: "";
	border-radius: 50%;
	background-color: #4a4a4a;
	margin: 0 4px;
	position: relative;
	top: ${(props)=>props.topPos ? '6px' : '-2px'};
`;

export const HotelDataWrapper = styled(GenericDiv)`
	display: ${(props)=> !props.isMobile && 'grid'};
	grid-template-columns: ${(props) => !props.isMobile && '60% 40%'}
`;
